module.exports = __webpack_public_path__ + "media/images/front/pc/default/doctor_profile_noimage-4f88e095035f1194281b459bc8b5439b.png";